import { DefaultService as TechnologiesSDK } from '@atbay/technology-service-node-sdk'
import { createClient } from '@core/base/http-client'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const TechnologiesClient = createClient(TechnologiesSDK)
